// @flow
import styled from "styled-components"
import { lighten } from "global/theme"
import { Wrap } from "componentsStyled/Layout/Wrap"

export const HighlightedWrap = styled(Wrap)`
  background: ${(props) => lighten(
    props.theme.color.primaryAccent,
    0.1,
  )};
`;

export const CancellationDetailsWrap = styled(Wrap)`
  background: ${(props) => props.theme.color.light};
  border: none;
`



// WEBPACK FOOTER //
// ./src/pages/Reservation/styled.js